import React, { useState, useEffect, useMemo } from 'react';
import { Card, Row, Col, Input, Button, Table, message, Form, Space, Select, Modal, Typography, Tag, Spin } from "antd";
import { DeleteOutlined, PlusOutlined, EditOutlined, EyeOutlined, SearchOutlined, ReloadOutlined, FilePdfOutlined } from "@ant-design/icons";
import { getCaseSummaryApi, deleteCaseSummaryApi } from '../../../api/master.api';
import { Link } from 'react-router-dom';

const { Title } = Typography;
const { Option } = Select;
import { useAuth } from "../../../context/AuthContext";
const CaseSummaryReport = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchMonth, setSearchMonth] = useState("");
    const [searchYear, setSearchYear] = useState("");
 const { user, logout } = useAuth();
    // Load existing cases on component mount
    useEffect(() => {
        loadExistingCases();
    }, []);
    let count = 0;
    const loadExistingCases = async () => {
        setLoading(true);
        try {
            const response = await getCaseSummaryApi();
            count++;
            console.log("response", response);
            console.log("count", count);
            if (response.data.success) {
                const items = response.data.data || [];
                setData(items);
                // console.log("items", items);
                // message.success(`${items.length} টি রেকর্ড পাওয়া গেছে`);
                setLoading(false);
            } else {
                setData([]);
                message.info("কোনো রেকর্ড পাওয়া যায়নি");
            }
        } catch (error) {
            console.error('Error loading cases:', error);
            message.error("ডাটা লোড করতে সমস্যা হয়েছে");
            setData([]);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (caseId) => {
        try {
            await deleteCaseSummaryApi(caseId);
            message.success("সফলভাবে মুছে ফেলা হয়েছে");
            loadExistingCases();
        } catch (error) {
            console.error('Error deleting case:', error);
            message.error("মুছে ফেলতে ব্যর্থ হয়েছে");
        }
    };

    const filteredEntries = useMemo(() => {
        return data.filter((item) => {
            const yearMatch = !searchYear ||
                (item.year || item.YEAR || "")
                    .toString()
                    .toLowerCase()
                    .includes(searchYear.toString().toLowerCase());

            const monthMatch = !searchMonth ||
                (item.month || item.MONTH || "") === searchMonth;

            return yearMatch && monthMatch;
        });
    }, [data, searchMonth, searchYear]);

    const columnsForExistingCases = [
        {
            title: 'ক্রমিক নং',
            key: 'serial',
            width: 80,
            align: 'center',
            render: (_, __, index) => index + 1,
        },
        {
            title: 'মাস',
            dataIndex: 'month',
            key: 'month',
            width: 120,
            align: 'center',
            render: (text, record) => record.month || record.MONTH || '-',
        },
        {
            title: 'বছর',
            dataIndex: 'year',
            key: 'year',
            width: 100,
            align: 'center',
            render: (text, record) => record.year || record.YEAR || '-',
        },
        {
            title: 'তৈরির তারিখ',
            dataIndex: 'created_date',
            key: 'created_date',
            width: 150,
            align: 'center',
            render: (text, record) => {
                const date = record.created_date || record.CREATED_DATE || record.created_at;
                if (date) {
                    return new Date(date).toLocaleDateString('bn-BD');
                }
                return '-';
            },
        },
        {
            title: 'তৈরিকারী',
            dataIndex: 'created_by',
            key: 'created_by',
            width: 120,
            align: 'center',
            render: (text, record) => record.created_by || record.CREATED_BY || '-',
        },
        {
            title: 'কার্যক্রম',
            key: 'action',
            width: 180,
            align: 'center',
            render: (_, record) => (
                <Space size="small">
                    <Link to={`/case-summary-view/${record.case_id || record.CASE_ID}`}>
                        <Button
                            type="primary"
                            icon={<EyeOutlined />}
                            size="small"
                            style={{ backgroundColor: '#1890ff' }}
                        >
                            দেখুন
                        </Button>
                    </Link>
                    {
                        user.role ==="admin"&&(<Button
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => {
                            Modal.confirm({
                                title: 'নিশ্চিত করুন',
                                content: 'আপনি কি এই রেকর্ডটি মুছে ফেলতে চান?',
                                okText: 'হ্যাঁ',
                                cancelText: 'না',
                                onOk: () => handleDelete(record.case_id || record.CASE_ID)
                            });
                        }}
                        size="small"
                    >
                        মুছুন
                    </Button>)
                    }
                    
                </Space>
            ),
        },
    ];

    const monthOptions = [
        { value: 'জানুয়ারি', label: 'জানুয়ারি' },
        { value: 'ফেব্রুয়ারি', label: 'ফেব্রুয়ারি' },
        { value: 'মার্চ', label: 'মার্চ' },
        { value: 'এপ্রিল', label: 'এপ্রিল' },
        { value: 'মে', label: 'মে' },
        { value: 'জুন', label: 'জুন' },
        { value: 'জুলাই', label: 'জুলাই' },
        { value: 'আগস্ট', label: 'আগস্ট' },
        { value: 'সেপ্টেম্বর', label: 'সেপ্টেম্বর' },
        { value: 'অক্টোবর', label: 'অক্টোবর' },
        { value: 'নভেম্বর', label: 'নভেম্বর' },
        { value: 'ডিসেম্বর', label: 'ডিসেম্বর' }
    ];

    const handleReset = () => {
        setSearchMonth("");
        setSearchYear("");
        loadExistingCases();
    };

    return (
        <div style={{ background: "#f0f2f5", minHeight: "100vh", padding: "24px" }}>
            <div style={{ maxWidth: 1400, margin: "0 auto" }}>
                {/* Header */}
                <Card style={{ marginBottom: 24, borderRadius: 12 }}>
                    <Row justify="space-between" align="middle">
                        <Col>
                            <Title level={3} style={{ margin: 0, color: "#1a5f7a" }}>
                                মামলা সংক্রান্ত তথ্য
                            </Title>
                            <Tag color="blue" style={{ marginTop: 8 }}>
                                কেস সামারি রিপোর্ট
                            </Tag>
                        </Col>
                        <Col>
                            <Button
                                icon={<ReloadOutlined />}
                                onClick={() => loadExistingCases()}
                                loading={loading}
                            >
                                রিফ্রেশ
                            </Button>
                        </Col>
                    </Row>
                </Card>

                {/* Filter Section */}
                <Card style={{ marginBottom: 24, borderRadius: 12 }}>
                    <Title level={5} style={{ marginBottom: 16 }}>অনুসন্ধান ফিল্টার</Title>
                    <Row gutter={16}>
                        <Col xs={24} sm={12} md={6}>
                            <Input
                                placeholder="বছর অনুসন্ধান (যেমন: ২০২৫)"
                                prefix={<SearchOutlined />}
                                value={searchYear}
                                onChange={(e) => setSearchYear(e.target.value)}
                                allowClear
                                size="large"
                                onPressEnter={() => loadExistingCases()}
                            />
                        </Col>
                        <Col xs={24} sm={12} md={6}>
                            <Select
                                allowClear
                                placeholder="মাস নির্বাচন করুন"
                                value={searchMonth || undefined}
                                onChange={(v) => setSearchMonth(v || "")}
                                style={{ width: "100%" }}
                                size="large"
                                showSearch
                                optionFilterProp="children"
                            >
                                {monthOptions.map((month) => (
                                    <Option key={month.value} value={month.value}>
                                        {month.label}
                                    </Option>
                                ))}
                            </Select>
                        </Col>
                        <Col xs={24} sm={12} md={6}>
                            <Button
                                type="primary"
                                onClick={loadExistingCases}
                                size="large"
                                style={{ backgroundColor: "#52c41a", borderColor: "#52c41a" }}
                            >
                                অনুসন্ধান করুন
                            </Button>
                        </Col>
                        <Col xs={24} sm={12} md={6}>
                            <Button
                                onClick={handleReset}
                                size="large"
                            >
                                রিসেট করুন
                            </Button>
                        </Col>
                    </Row>
                </Card>



                {/* Data Table */}
                <Card
                    title="মামলার তথ্যের তালিকা"
                    style={{ borderRadius: 12 }}
                    headStyle={{ backgroundColor: "#fafafa", borderBottom: "2px solid #1a5f7a" }}
                >
                    <Table
                        columns={columnsForExistingCases}
                        dataSource={filteredEntries}
                        rowKey={(record) => record.case_id || record.CASE_ID || record.id}
                        loading={loading}
                        pagination={{
                            pageSize: 10,
                            showSizeChanger: true,
                            showTotal: (total, range) =>
                                `${range[0]} থেকে ${range[1]} পর্যন্ত, মোট ${total} টি রেকর্ড`,
                            pageSizeOptions: ['10', '20', '50', '100']
                        }}
                        size="middle"
                        bordered
                        scroll={{ x: 1024 }}
                        locale={{
                            emptyText: loading ? "লোড হচ্ছে..." : "কোনো তথ্য পাওয়া যায়নি"
                        }}
                    />
                </Card>

                {/* No Data Message */}
                {!loading && filteredEntries.length === 0 && data.length > 0 && (
                    <Card style={{ marginTop: 24, textAlign: 'center', borderRadius: 12 }}>
                        <p style={{ fontSize: 16, color: "#999" }}>
                            আপনার অনুসন্ধানের সাথে মিলে যাওয়া কোনো রেকর্ড পাওয়া যায়নি।
                        </p>
                        <Button onClick={handleReset}>
                            সব রেকর্ড দেখুন
                        </Button>
                    </Card>
                )}

                {/* Loading State */}
                {loading && (
                    <div style={{ textAlign: 'center', padding: '50px' }}>
                        <Spin size="large" tip="লোড হচ্ছে..." />
                    </div>
                )}
            </div>
        </div>
    );
};

export default CaseSummaryReport;